module.exports = __webpack_public_path__ + "img/2.25af6d21.png";